<template lang="pug" src="./driver-bonuses.pug"></template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        requestProcessing: false
    }),
    computed: {
        ...mapState({
            items: state => state.bonuses.driver.items,
            pagination: state => state.bonuses.driver.pagination
        }),
        headers() {
            return [
                'title', 'description', 'targetType', 'type', 'bonusFrequency', 'bonusValue',
                'bonusMaxAmount', 'bonusMaxOrderAmount', 'fixedBonusAmount', 'startDate', 'endDate', 'isActive',
                'brandId', 'driverCount', 'receivedBonuses', 'actions'
            ].map(it => ({
                text: this.$vuetify.lang.t(`$vuetify.pages.Bonuses.table.${it}`),
                value: it,
                sortable: false,
                align: 'center'
            }));
        }
    },
    created() {
        this.loadDriverBonuses();
    },
    methods: {
        loadDriverBonuses(page = 1) {
            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('bonuses/getDriverBonuses', { page }).then(() => {
                this.$nextTick(() => {
                    this.requestProcessing = false;
                });
            });
        },
        onPageChange(page) {
            if (page !== this.pagination.page) {
                this.loadDriverBonuses(page);
            }
        }
    }
};
</script>
